import { render } from "./SelecionarJogadores.vue?vue&type=template&id=50f082bc&scoped=true"
import script from "./SelecionarJogadores.vue?vue&type=script&lang=js"
export * from "./SelecionarJogadores.vue?vue&type=script&lang=js"

import "./SelecionarJogadores.vue?vue&type=style&index=0&id=50f082bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f082bc"]])

export default __exports__